import { COMMON, CERTIFICATE } from 'pages/provisioning/aws/nlb/utils/constants';

export const formOrderObjFromCart = (data = null) => {
    const entityDetails = data?.itemDetail?.entityDetails || null;
    const environmentDetails = data?.itemDetail?.catalogService?.catalogConfig?.environmentDetails || null;
    const catalogConfig = data?.itemDetail?.catalogService?.catalogConfig || null;
    // Build multi-select targets from catalogConfig targetGroups arrays
    const instanceIds = catalogConfig?.targetGroups?.instanceId;
    const instanceNames = catalogConfig?.targetGroups?.instanceName;
    let targetsDetail = null;
    let targets = null;
    if (Array.isArray(instanceIds) && Array.isArray(instanceNames) && instanceIds.length === instanceNames.length) {
        targetsDetail = instanceIds.map((id, idx) => {
            const displayName = instanceNames[idx];
            const labelValue = `${id} (${displayName})`;
            return {
                label: labelValue,
                value: labelValue,
                data: { id, displayName },
            };
        });
        targets = targetsDetail.map((t) => t.value);
    }
    return {
        entityDetails: {
            ...entityDetails,
        },
        appProfile: entityDetails?.name,
        ...(entityDetails?.name && { appProfileDetails: { label: entityDetails?.name, value: entityDetails?.name } }),
        sector: catalogConfig?.sector || null,
        environment: catalogConfig?.environment || null,
        appRegion: catalogConfig?.applicationRegion || null,
        department: catalogConfig?.department || null,
        applicationName: catalogConfig?.applicationName || null,
        appShortName: catalogConfig?.applicationShortName || null,
        appUrl: catalogConfig?.applicationUrl || null,
        certificate: catalogConfig?.supportBackendCertificate || null,
        adCertGroup: catalogConfig?.activeDirectoryCertificateGroup || null,
        appSupportMailId: catalogConfig?.appSupportMailId || null,
        hCode: environmentDetails?.costCenter || null,
        ...(environmentDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter, projectName: environmentDetails?.projectName },
        }),
        ...(!environmentDetails?.costCenter && { hCodeDetails: null }),
        appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            gpid: entityDetails?.applicationManagerGpid,
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
        },
        awsAccountId: catalogConfig?.accountId,
        availabilityZone:
            catalogConfig?.availabilityZone?.map((item) => ({
                label: item,
                value: item,
            })) || null,
        nlbName: catalogConfig?.nlbConfiguration?.nlbName,
        crossZone: catalogConfig?.nlbConfiguration?.crossZone ? COMMON.ENABLED : COMMON.DISABLED,
        loadBalancerType: catalogConfig?.nlbConfiguration?.nlbType,
        listenerPort: catalogConfig?.listeners?.port,
        listenerProtocol: catalogConfig?.listeners?.protocol,
        targetGrpName: catalogConfig?.targetGroups?.name,
        targetType: catalogConfig?.targetGroups?.targetType,
        ipAddress: catalogConfig?.targetGroups?.ips?.[0],
        ...(catalogConfig?.targetGroups?.ips && { isAKSRequired: 'yes', ipIsAvailable: true }),
        targets,
        targetsDetail,
        targetProtocol: catalogConfig?.targetGroups?.protocol,
        targetPort: catalogConfig?.targetGroups?.port,
        hcProtocol: catalogConfig?.healthCheck?.protocol,
        hcPath: catalogConfig?.healthCheck?.path,
        hcPort: catalogConfig?.healthCheck?.port,
        ...(catalogConfig?.componentName && { componentName: catalogConfig?.componentName }),
        ...(catalogConfig?.securityGroupId && {
            componentNameDetails: {
                ACSG_GroupId: catalogConfig?.securityGroupId,
                ACSG_ComponentName: catalogConfig?.componentName,
                ACSG_Name: catalogConfig?.securityGroupName || null,
            },
        }),
        idleTimeout: catalogConfig?.healthCheck?.timeout,
        catalogCode: data?.itemDetail?.catalogService?.catalogServiceCode,
        catalogType: data?.itemDetail?.catalogService?.catalogType,
        cloudProvider: data?.itemDetail?.catalogService?.cloudProvider,
        cloudService: data?.itemDetail?.catalogService?.cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};

export const formOrderObjFromOrderDetails = (catalogServiceId = null, data = null) => {
    const entityDetails = data?.entityDetails || null;
    const catalog = data?.catalogServices?.find((item) => item?.catalogServiceId === catalogServiceId) || null;
    const catalogConfig = catalog?.catalogConfig || null;
    const environmentDetails = catalogConfig?.environmentDetails || null;
    const instanceIds = catalogConfig?.targetGroups?.instanceId;
    const instanceNames = catalogConfig?.targetGroups?.instanceName;
    let targetsDetail = null;
    let targets = null;
    if (Array.isArray(instanceIds) && Array.isArray(instanceNames) && instanceIds.length === instanceNames.length) {
        targetsDetail = instanceIds.map((id, idx) => {
            const displayName = instanceNames[idx];
            const labelValue = `${id} (${displayName})`;
            return {
                label: labelValue,
                value: labelValue,
                data: { id, displayName },
            };
        });
        targets = targetsDetail.map((t) => t.value);
    }
    return {
        entityDetails: {
            ...entityDetails,
        },
        appProfile: entityDetails?.name,
        ...(entityDetails?.name && { appProfileDetails: { label: entityDetails?.name, value: entityDetails?.name } }),
        sector: catalogConfig?.sector || null,
        environment: catalogConfig?.environment || null,
        appRegion: catalogConfig?.applicationRegion || null,
        department: catalogConfig?.department || null,
        applicationName: catalogConfig?.applicationName || null,
        appShortName: catalogConfig?.applicationShortName || null,
        appUrl: catalogConfig?.applicationUrl || null,
        certificate: catalogConfig?.supportBackendCertificate || null,
        adCertGroup: catalogConfig?.activeDirectoryCertificateGroup || null,
        appSupportMailId: catalogConfig?.appSupportMailId || null,
        hCode: environmentDetails?.costCenter || null,
        ...(environmentDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter, projectName: environmentDetails?.projectName },
        }),
        ...(!environmentDetails?.costCenter && { hCodeDetails: null }),
        appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            gpid: entityDetails?.applicationManagerGpid,
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
        },
        awsAccountId: catalogConfig?.accountId,
        availabilityZone:
            catalogConfig?.availabilityZone?.map((item) => ({
                label: item,
                value: item,
            })) || null,
        nlbName: catalogConfig?.nlbConfiguration?.nlbName,
        crossZone: catalogConfig?.nlbConfiguration?.crossZone ? COMMON.ENABLED : COMMON.DISABLED,
        loadBalancerType: catalogConfig?.nlbConfiguration?.nlbType,
        listenerPort: catalogConfig?.listeners?.port,
        listenerProtocol: catalogConfig?.listeners?.protocol,
        targetGrpName: catalogConfig?.targetGroups?.name,
        targetType: catalogConfig?.targetGroups?.targetType,
        ipAddress: catalogConfig?.targetGroups?.ips?.[0],
        ...(catalogConfig?.targetGroups?.ips && { isAKSRequired: 'yes', ipIsAvailable: true }),
        targets,
        targetsDetail,
        targetProtocol: catalogConfig?.targetGroups?.protocol,
        targetPort: catalogConfig?.targetGroups?.port,
        hcProtocol: catalogConfig?.healthCheck?.protocol,
        hcPath: catalogConfig?.healthCheck?.path,
        hcPort: catalogConfig?.healthCheck?.port,
        ...(catalogConfig?.componentName && { componentName: catalogConfig?.componentName }),
        ...(catalogConfig?.securityGroupId && {
            componentNameDetails: {
                ACSG_GroupId: catalogConfig?.securityGroupId,
                ACSG_ComponentName: catalogConfig?.componentName,
                ACSG_Name: catalogConfig?.securityGroupName || null,
            },
        }),
        idleTimeout: catalogConfig?.healthCheck?.timeout,
        catalogCode: catalog?.catalogServiceCode,
        catalogType: catalog?.catalogType,
        cloudProvider: catalog?.cloudProvider,
        cloudService: catalog?.cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};
export const resetCostEstimateDetails = {
    details: [],
    qty: null,
    totalOneTimeCost: {
        frequency: 'one time cost',
        estCost: null,
        currency: 'USD',
    },
    totalRecurringCost: {
        frequency: 'per item per month',
        estCost: null,
        currency: 'USD',
    },
    notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
};
export const resetOrder = {
    entityDetails: null,
    appProfile: null,
    appProfileDetails: null,
    sector: null,
    environment: null,
    appRegion: null,
    department: null,
    applicationName: null,
    appShortName: null,
    appUrl: null,
    certificate: null,
    adCertGroup: null,
    appSupportMailId: null,
    hCode: null,
    hCodeDetails: null,
    appOwner: null,
    appOwnerDetails: null,
    awsAccountId: null,
    awsAccountName: null,
    availabilityZone: null,
    nlbName: null,
    crossZone: COMMON?.DISABLED,
    loadBalancerType: 'internal',
    listenerPort: null,
    listenerProtocol: null,
    targetGrpName: null,
    targetType: 'instance',
    isAKSRequired: 'no',
    targets: null,
    targetsDetail: null,
    targetProtocol: null,
    targetPort: null,
    hcProtocol: null,
    hcPath: null,
    hcPort: null,
    idleTimeout: null,
    catalogCode: null,
    catalogType: null,
    cloudProvider: null,
    cloudService: null,
    validationStatus: 'clearValidation',
    isTouched: false,
};
export const resetToggleSspModal = {
    isCost: { costType: '', isCostOpen: false },
    isSubmitOrderSuccess: false,
    isCostSplitOpen: false,
};
export const environmentConfig = {
    development: {
        regex: /^((?:(?!azure|aws|gcp|ite)[a-z0-9-]){3,20})\.dev\.(mypepsico|pepsico|aws\.intra\.pepsico)\.com$/,
        message: `Application URL is Invalid. Must be in the format: <appshortname>.dev.mypepsico.com, <appshortname>.dev.pepsico.com, or <appshortname>.dev.aws.intra.pepsico.com (where <appshortname> is 3–20 lowercase characters, must not contain '.', and may include hyphens). (e.g., devx-infra.dev.mypepsico.com)\nNote: <appshortname> must not contain any cloud-specific terms such as 'azure', 'aws', 'gcp' or 'ite.`,
    },
    qa: {
        regex: /^((?:(?!azure|aws|gcp|ite)[a-z0-9-]){3,20})\.qa\.(mypepsico|pepsico|aws\.intra\.pepsico)\.com$/,
        message: `Application URL is Invalid. Must be in the format: <appshortname>.qa.mypepsico.com, <appshortname>.qa.pepsico.com, or <appshortname>.qa.aws.intra.pepsico.com (where <appshortname> is 3–20 lowercase characters, must not contain '.', and may include hyphens). (e.g., devx-infra.qa.pepsico.com)\nNote: <appshortname> must not contain any cloud-specific terms such as 'azure', 'aws', 'gcp' or 'ite'.`,
    },
    'pre-production': {
        regex: /^((?:(?!azure|aws|gcp|ite)[a-z0-9-]){3,20})\.preprod\.(mypepsico|pepsico|aws\.intra\.pepsico)\.com$/,
        message: `Application URL is Invalid. Must be in the format: <appshortname>.preprod.mypepsico.com, <appshortname>.preprod.pepsico.com, or <appshortname>.preprod.aws.intra.pepsico.com (where <appshortname> is 3–20 lowercase characters, must not contain '.', and may include hyphens). (e.g., devx-infra.preprod.pepsico.com)\nNote: <appshortname> must not contain any cloud-specific terms such as 'azure', 'aws', 'gcp' or 'ite'.`,
    },
    production: {
        regex: /^((?:(?!azure|aws|gcp|ite)[a-z0-9-]){3,20})\.(mypepsico|pepsico|aws\.intra\.pepsico)\.com$/,
        message: `Application URL is Invalid. Must be in the format: <appshortname>.mypepsico.com, <appshortname>.pepsico.com, or <appshortname>.aws.intra.pepsico.com (where <appshortname> is 3–20 lowercase characters, must not contain '.', and may include hyphens). (e.g., devx-infra.pepsico.com)\nNote: <appshortname> must not contain any cloud-specific terms such as 'azure', 'aws', 'gcp' or 'ite'.`,
    },
};

export const validateAppURL = (url, environment) => {
    const config = environmentConfig[environment?.toLowerCase()];

    if (!config) {
        return {
            isValid: false,
            message: 'Invalid environment specified',
        };
    }
    let isValid = {
        isValid: true,
        message: '',
    };
    if (url !== null && url !== '') {
        isValid = config.regex.test(url);
    }
    return {
        isValid,
        message: isValid ? 'Valid URL' : config.message,
    };
};

export const validateIpAddress = (ip) => {
    if (!ip) return { isValid: false, message: 'IP address is required' };
    const parts = ip?.split?.('.') || [];
    if (parts?.length !== 4) {
        return { isValid: false, message: 'Format must be 4 numbers (e.g. 10.0.0.1)' };
    }

    // Map each part to an error (if any), then find the first error
    const error = parts
        .map((part, index) => {
            if (!/^\d+$/.test(part)) {
                return { isValid: false, message: 'Must contain only numbers' };
            }
            const num = parseInt(part, 10);

            if (num < 0 || num > 255) {
                return { isValid: false, message: `Value ${part} is out of range (0-255)` };
            }
            if (index === 0 && num < 10) {
                return { isValid: false, message: `First octet must be between 10 and 255. Found: ${num}` };
            }
            if (part?.length > 1 && part?.startsWith('0')) {
                return { isValid: false, message: `Leading zero not allowed in ${part}` };
            }

            return null;
        })
        .find((result) => result !== null);

    return error || { isValid: true, message: 'Valid IP address' };
};

const REGEX_ENTRUST = /^([a-zA-Z0-9-]{3,20})\.(mypepsico|pepsico)\.com$|^([a-zA-Z0-9-]{3,20})\.(dev|qa|preprod|ite)\.(mypepsico|pepsico)\.com$/;
const REGEX_PECA = /^([a-zA-Z0-9-]{3,20})\.(aws\.intra\.pepsico)\.com$|^([a-zA-Z0-9-]{3,20})\.(dev|qa|preprod|ite)\.(aws\.intra\.pepsico)\.com$/;

/**
 * Returns certificate type for a given application URL.
 * @param {string} applicationUrl
 * @param {string} environment
 * @returns {'Entrust Certificate' | 'Pepsico Enterprise CA Certificate' | null}
 */
export const resolveBackendCertificate = (applicationUrl, environment) => {
    if (!applicationUrl) return null;
    const { isValid } = validateAppURL(applicationUrl, environment);
    if (!isValid) return null;
    if (REGEX_ENTRUST.test(applicationUrl)) return CERTIFICATE.ENTRUST;
    if (REGEX_PECA.test(applicationUrl)) return CERTIFICATE.PEP_ENTERPRISE;
    return null;
};
export * from './subnetUtils';
